import { commonAxios } from "../../Global/CommonAxios"
import { setAlert } from "./AlertActions"


// dotask................................

export const onFetchCategory = (setData, loader, setLoader) => (dispatch, getState) => {
    commonAxios("get_category", {}, dispatch, getState().auth.token)
        .then((res) => {
            if (res.status) {
                setData(res.data)
            }
            setLoader({
                ...loader,
                fetch: false
            })
        }).catch((err) => {
            setLoader({
                ...loader,
                fetch: false
            })
            console.log(err)
            dispatch(setAlert(err.msg, "danger"))
        })
}
export const onFetchLevel = (setData, loader, setLoader) => (dispatch, getState) => {
    commonAxios("get_level", {}, dispatch, getState().auth.token)
        .then((res) => {
            if (res.status) {
                setData(res.data)
            }
            setLoader({
                ...loader,
                fetch: false
            })
        }).catch((err) => {
            setLoader({
                ...loader,
                fetch: false
            })
            console.log(err)
            dispatch(setAlert(err.msg, "danger"))
        })
}
export const onFetchMedia = (setData, loader, setLoader) => (dispatch, getState) => {
    commonAxios("social-media", {}, dispatch, getState().auth.token)
        .then((res) => {
            if (res.status) {
                setData(res.data)
            }
            setLoader({
                ...loader,
                fetch: false
            })
        }).catch((err) => {
            setLoader({
                ...loader,
                fetch: false
            })
            console.log(err)
            dispatch(setAlert(err.msg, "danger"))
        })
}
export const onFetchTaskType = (setData, loader, setLoader) => (dispatch, getState) => {
    commonAxios("task-type", {}, dispatch, getState().auth.token)
        .then((res) => {
            if (res.status) {
                setData(res.data)
            }
            setLoader({
                ...loader,
                fetch: false
            })
        }).catch((err) => {
            setLoader({
                ...loader,
                fetch: false
            })
            console.log(err)
            dispatch(setAlert(err.msg, "danger"))
        })
}
export const onFetchCretorId = (setData, loader, setLoader) => (dispatch, getState) => {
    commonAxios("fetch-creator", {}, dispatch, getState().auth.token)
        .then((res) => {
            if (res.status) {
                setData(res.data)
            }
            setLoader({
                ...loader,
                fetch: false
            })
        }).catch((err) => {
            setLoader({
                ...loader,
                fetch: false
            })
            console.log(err)
            dispatch(setAlert(err.msg, "danger"))
        })
}
export const onFetchAttachment = (setData, loader, setLoader) => (dispatch, getState) => {
    commonAxios("attachment-type", {}, dispatch, getState().auth.token)
        .then((res) => {
            if (res.status) {
                setData(res.data)
            }
            setLoader({
                ...loader,
                fetch: false
            })
        }).catch((err) => {
            setLoader({
                ...loader,
                fetch: false
            })
            console.log(err)
            dispatch(setAlert(err.msg, "danger"))
        })
}

export const onCreatePublishTaskAdmin = (data, navigation, loader, setLoader) => (dispatch, getState) => {
    let config = {
        headers: {
            'Authorization': getState().auth.token,
            "Content-Type": "multipart/form-data",
        }
    }

    commonAxios("create-admin-task", data, dispatch, getState().auth.token, config)
        .then((res) => {
            if (res.status) {
                navigation('/admin/all-task')
                dispatch(setAlert(res.msg, "success"))
            } else {
                dispatch(setAlert(res.msg, "danger"))
            }
            setLoader({
                ...loader,
                create: false
            })
        }).catch((err) => {
            setLoader({
                ...loader,
                create: false
            })
            console.log(err)
            dispatch(setAlert(err.msg, "danger"))
        })
}

export const onCreatePublishTask = (data, navigation, loader, setLoader) => (dispatch, getState) => {
    let config = {
        headers: {
            'Authorization': getState().auth.token,
            "Content-Type": "multipart/form-data",
        }
    }

    commonAxios("create-task", data, dispatch, getState().auth.token, config)
        .then((res) => {
            if (res.status) {
                navigation('/creator/task')
                localStorage.removeItem("data");
                // navigation('/amountpage', { state: { "payment_id": res.data.payment_id } })
                dispatch(setAlert(res.msg, "success"))
            } else {
                dispatch(setAlert(res.msg, "danger"))
            }
            setLoader({
                ...loader,
                create: false
            })
        }).catch((err) => {
            setLoader({
                ...loader,
                create: false
            })
            console.log(err)
            dispatch(setAlert(err.msg, "danger"))
        })
}


export const onFetchPublishTask = (url, formData, setData, loader, setLoader) => (dispatch, getState) => {
    commonAxios(url, formData, dispatch, getState().auth.token)
        .then((res) => {
            if (res.status) {
                setData(res.data.list)
                // setTotalLength(res.data.total_count)

            } else {
                setData([])
                // setTotalLength(0)
            }
            setLoader({
                ...loader,
                fetch: false
            })
        }).catch((err) => {
            setLoader({
                ...loader,
                fetch: false
            })
            console.log(err)
            dispatch(setAlert(err.msg, "danger"))
        })
}

export const onFetchTaskData = (data, setData, loader, setLoader) => (dispatch, getState) => {
    commonAxios("fetch-details", data, dispatch, getState().auth.token)
        .then((res) => {
            if (res.status) {

                setData({
                    ...res.data[0],
                    assets: [],
                    assets_name: [],
                    assets_type: [],
                    old_assets: []
                })
            }
            setLoader({
                ...loader,
                save: false
            })
        }).catch((err) => {
            setLoader({
                ...loader,
                save: false
            })
            console.log(err)
            dispatch(setAlert(err.msg, "danger"))
        })
}
export const onDuplicateTaskDataAdmin = (data, navigation, loader, setLoader) => (dispatch, getState) => {
    let config = {
        headers: {
            'Authorization': getState().auth.token,
            "Content-Type": "multipart/form-data",
        }
    }
    commonAxios("duplicate-task", data, dispatch, getState().auth.token, config)
        .then((res) => {
            if (res.status) {
                navigation('/admin/all-task')
            }
            setLoader({
                ...loader,
                create: false
            })
        }).catch((err) => {
            setLoader({
                ...loader,
                create: false
            })
            console.log(err)
            dispatch(setAlert(err.msg, "danger"))
        })
}
export const onUpdateTaskDataAdmin = (data, navigation, loader, setLoader) => (dispatch, getState) => {
    let config = {
        headers: {
            'Authorization': getState().auth.token,
            "Content-Type": "multipart/form-data",
        }
    }
    commonAxios("edit-admin-task", data, dispatch, getState().auth.token, config)
        .then((res) => {
            if (res.status) {
                navigation('/admin/all-task')
            }
            setLoader({
                ...loader,
                create: false
            })
        }).catch((err) => {
            setLoader({
                ...loader,
                create: false
            })
            console.log(err)
            dispatch(setAlert(err.msg, "danger"))
        })
}
export const onUpdateTaskData = (data, navigation, loader, setLoader) => (dispatch, getState) => {
    let config = {
        headers: {
            'Authorization': getState().auth.token,
            "Content-Type": "multipart/form-data",
        }
    }
    commonAxios("update-task", data, dispatch, getState().auth.token, config)
        .then((res) => {
            if (res.status) {
                navigation('/creator/task')
            }
            setLoader({
                ...loader,
                create: false
            })
        }).catch((err) => {
            setLoader({
                ...loader,
                create: false
            })
            console.log(err)
            dispatch(setAlert(err.msg, "danger"))
        })
}

export const FetchAmountdetails = (data, setSubmissionData, loader, setLoader) => (dispatch, getState) => {
    commonAxios("get-payment", data, dispatch, getState().auth.token)
        .then((res) => {
            if (res.status) {
                setSubmissionData(res.data[0]);
            } else {
                dispatch(setAlert(res.msg, "danger"));
            }
            setLoader({
                ...loader,
                fetch: false
            });

        }).catch((err) => {
            console.log(err);
            setLoader({
                ...loader,
                fetch: false
            });

        });
}
export const FetchTaskUserSubmissionData = (SubData, loader, setSubmissionData, setLoader, setTotalLength) => (dispatch, getState) => {
    commonAxios("fetch-usertask-submission", SubData, dispatch, getState().auth.token)
        .then((res) => {
            if (res.status) {
                setSubmissionData(res.data.list);
                setTotalLength(res.data.total_count)
            } else {
                dispatch(setAlert(res.msg, "danger"));
            }
            setLoader({
                ...loader,
                fetch: false
            });

        }).catch((err) => {
            console.log(err);
            setLoader({
                ...loader,
                fetch: false
            });

        });
}

export const onFetchReviewDetails = (data, loader, setLoader, setData, setAverageData, setLengthData, setAverageReview) => (dispatch, getState) => {
    commonAxios("fetch-task-review", data, dispatch, getState().auth.token)
        .then((res) => {
            if (res.status) {
                setData(res.data.allreview);
                setAverageData(res.data.overallrating);
                setLengthData(res.data.totalreview)
                setAverageReview(res.data.averagerating)
            } else {
                // dispatch(setAlert(res.msg, "danger"));
            }
            setLoader({
                ...loader,
                fetch: false
            });

        }).catch((err) => {
            console.log(err);
            setLoader({
                ...loader,
                fetch: false
            });

        });
}
export const SubmissionTaskApprove = (data, loader, setLoader, handleClose, fetchData) => (dispatch, getState) => {

    commonAxios("approve-task", data, dispatch, getState().auth.token)
        .then((res) => {

            if (res.status) {
                fetchData()
                dispatch(setAlert(res.msg, "success"))


            } else {

                dispatch(setAlert(res.msg, "danger"))
            }
            setLoader({
                ...loader,
                approve: false
            })
            handleClose()
        }).catch((err) => {
            console.log(err)
            setLoader({
                ...loader,
                approve: false
            })

        })
}

export const SubmissionTaskReject = (data, loader, setLoader, handleClose, fetchData) => (dispatch, getState) => {

    commonAxios("reject-task", data, dispatch, getState().auth.token)
        .then((res) => {

            if (res.status) {
                fetchData()
                dispatch(setAlert(res.msg, "success"))

            } else {
                console.log(res.msg)
                dispatch(setAlert(res.msg, "danger"))
            }
            setLoader({
                ...loader,
                reject: false
            })
            handleClose()
        }).catch((err) => {
            console.log(err)
            setLoader({
                ...loader,
                reject: false
            })

        })
}
export const submitUserReview = (data, setLoader, handleModalFalse) => (dispatch, getState) => {

    commonAxios("submit-user-review", data, dispatch, getState().auth.token)
        .then((res) => {

            if (res.status) {

                dispatch(setAlert(res.msg, "success"))

            } else {
                console.log(res.msg)
                dispatch(setAlert(res.msg, "danger"))
            }
            setLoader(false)
            handleModalFalse()
        }).catch((err) => {
            console.log(err)
            setLoader(false)

        })
}
export const onDeleteTask = (data, fetchPublishTask, setLoader) => (dispatch, getState) => {

    commonAxios("delete-task", data, dispatch, getState().auth.token)
        .then((res) => {

            if (res.status) {

                dispatch(setAlert(res.msg, "success"))

            } else {
                console.log(res.msg)
                dispatch(setAlert(res.msg, "danger"))
            }

            fetchPublishTask()
            setLoader(false)
        }).catch((err) => {
            console.log(err)

        })
}


export const onFetchReview = (setReviewData, loader, setLoader) => (dispatch, getState) => {
    commonAxios("fetch-creator-review", {}, dispatch, getState().auth.token)
        .then((res) => {
            if (res.status) {
                setReviewData(res.data)
            } else {
                setReviewData([])
            }
            setLoader({
                ...loader,
                fetch: false
            })
        }).catch((err) => {
            setLoader({
                ...loader,
                fetch: false
            })
            console.log(err)
            dispatch(setAlert(err.msg, "danger"))
        })
}

export const onFetchSpending = (SetSpendingData, loader, setLoader) => (dispatch, getState) => {
    commonAxios("creator-spending", {}, dispatch, getState().auth.token)
        .then((res) => {
            if (res.status) {
                SetSpendingData(res.data)
            } else {
                SetSpendingData([])
            }
            setLoader({
                ...loader,
                fetch: false
            })
        }).catch((err) => {
            setLoader({
                ...loader,
                fetch: false
            })
            console.log(err)
            dispatch(setAlert(err.msg, "danger"))
        })
}
export const onFetchDashboardData = (SetSpendingData, loader, setLoader) => (dispatch, getState) => {
    commonAxios("creator-dashboard", {}, dispatch, getState().auth.token)
        .then((res) => {
            if (res.status) {
                SetSpendingData(res.data)
            } else {
                SetSpendingData([])
            }
            setLoader({
                ...loader,
                fetch: false
            })
        }).catch((err) => {
            setLoader({
                ...loader,
                fetch: false
            })
            console.log(err)
            dispatch(setAlert(err.msg, "danger"))
        })
}
//******************************* */
export const createStepModelData = (data) => (dispatch) => {
    dispatch({ type: 'ADD_STEP_DATA', payload: data })
}